document.addEventListener('DOMContentLoaded', () => {
  if (window.Shopify && window.Shopify.designMode) return;

  const url = new URL(window.location.href);
  const isAllProducts = /\/collections\/all\/?$/.test(url.pathname);

  if (isAllProducts && !url.searchParams.has('sort_by')) {
    url.searchParams.set('sort_by', 'best-selling');
    window.location.replace(url.toString());
  }
});
